import { API_CARD_ROOT_ENDPOINT } from "./constants"
import { api } from "../api"
import { convertObjectKeysToCamelCase } from "../../utils/helpers"

export const fetchSensorValues = async (token, cardId, cardIndex) => {
    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_sensor_values`, { token, cardId, cardIndex })

        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        const data = await res.json()
        return data
    } catch (err) {
        console.error("Polling error:", err)
       // throw err
    }
}

export const fetchSensorMeta = async (token, cardId, cardIndex) => {
    try {
        const usersCardsData = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_sensor_meta`, { token, cardId, cardIndex })

        if (!usersCardsData.ok) //{ usersCardsData.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return usersCardsData.status

        const data = await usersCardsData.json()
        return data
    } catch (err) {
        console.error("Error fetching cards sensor meta data", err)
        //throw err
    }
}

//This should sit elsewhere
export const fetchCardDashboard = async (token, cardId, cardIndex) => {

    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_card_dashboard`, { token, cardId, cardIndex })

        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        const data = await res.json()
        return convertObjectKeysToCamelCase(data)
    } catch (err) {
        console.error("Polling error:", err)
        //throw err
    }

}

export const checkForUpdates = async (token, cardId, cardIndex) => {

    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/check_updates`, { token, cardId, cardIndex })

        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
    } catch (err) {
        console.error("Polling error:", err)
        //throw err
    }
}

export const fetchSensorLog = async (sensorSelector) => {

    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_sensor_log`,  sensorSelector)

        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
        const data = await res.json();
        return data
    } catch (err) {
        console.error("Polling error:", err)
        //throw err
    }
}

export const fetchSensorConfig = async (adata) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_sensor_config`, adata)
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
        // throw err
    }
}

export const saveSensorConfig = async (data) => {

    try {
        const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/write_sensor_config`, data)

        if (!res.ok) //{ res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
    } catch (err) {
        console.error("Polling error:", err)
        //throw err
    }
}